export interface ProviderEntry {
  enabled: boolean;
  apiKey?: string;
  baseUrl?: string;
}

export interface ProviderConfig {
  _global: {
    apiMode: "subscription" | "api-key";
    subscriptionStatus?: "active" | "inactive" | "none";
  };
  [providerId: string]: ProviderEntry | { apiMode: string; subscriptionStatus?: string };
}

const STORAGE_KEY = "kourai-provider-config";

const DEFAULTS: ProviderConfig = {
  _global: { apiMode: "subscription", subscriptionStatus: "none" },
  deepseek: { enabled: true },
  openai: { enabled: true },
};

function getDefaults(): ProviderConfig {
  return JSON.parse(JSON.stringify(DEFAULTS));
}

function getProviderConfig(): ProviderConfig {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return { ...getDefaults(), ...JSON.parse(raw) };
  } catch {
    /* ignore */
  }
  return getDefaults();
}

function saveProviderConfig(config: ProviderConfig) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  } catch {
    /* ignore */
  }
}

export function getGlobalApiMode(): "subscription" | "api-key" {
  const config = getProviderConfig();
  return (config._global as { apiMode: string }).apiMode as "subscription" | "api-key";
}

export function setGlobalApiMode(mode: "subscription" | "api-key") {
  const config = getProviderConfig();
  (config._global as { apiMode: string }).apiMode = mode;
  saveProviderConfig(config);
}

export function getProviderEntry(providerId: string): ProviderEntry {
  const config = getProviderConfig();
  const entry = config[providerId];
  if (entry && "enabled" in entry) return entry as ProviderEntry;
  return { enabled: true };
}

export function updateProviderConfig(providerId: string, entry: Partial<ProviderEntry>) {
  const config = getProviderConfig();
  const existing = getProviderEntry(providerId);
  config[providerId] = { ...existing, ...entry };
  saveProviderConfig(config);
}
